import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslateLangService } from '@core/bootstrap/translate-lang.service';

export function TranslateLangServiceFactory(
  translateLangService: TranslateLangService
) {
  return () => translateLangService.load();
}

export const appInitializerProviders: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: TranslateLangServiceFactory,
    deps: [TranslateLangService],
    multi: true,
  },
];
